import { cn } from "@/modules/lib/utils"
import { ScreenHeader } from "@/modules/ui/components/header"
import { word } from "@modules/core/utils/i18n"
import { LoadingPage } from "@/modules/ui/components/loadingPage"

export function ChatPageSuspense({ className, ...props }: { className?: string } & React.ComponentProps<"div">) {
  return (
    <div className={cn("flex w-full grow flex-col p-6", className)} {...props}>
      <ScreenHeader title={word("chat.header.title")} subTitle={word("chat.header.subTitle")} />
      <div className="chat flex">
        <LoadingPage />
      </div>
    </div>
  )
}
